import { createFileRoute } from '@tanstack/react-router';
import { HotelReservationDetail } from '@/pages/hotel/detail';

export const Route = createFileRoute('/protected/_layout/hotel/_layout/$id')({
  component: HotelReservationRoute,
});

function HotelReservationRoute() {
  const { id } = Route.useParams();
  return <HotelReservationDetail id={id} />;
}
